import React from 'react';

const pageStyle = {
  minHeight: '100vh',
  background: '#080e1a',
  color: '#fff',
  fontFamily: 'DM Sans, sans-serif',
  padding: '40px 20px'
};

const containerStyle = {
  maxWidth: '800px',
  margin: '0 auto'
};

const headingStyle = {
  fontFamily: 'Syne, sans-serif',
  fontSize: '36px',
  fontWeight: '800',
  marginBottom: '8px',
  background: 'linear-gradient(135deg,#00c853,#1de9b6)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
};

const subHeadingStyle = {
  fontSize: '18px',
  fontWeight: '700',
  color: '#00c853',
  marginTop: '32px',
  marginBottom: '12px'
};

const textStyle = {
  fontSize: '14px',
  color: '#94a3b8',
  lineHeight: '1.8',
  marginBottom: '16px'
};

const cardStyle = {
  background: 'rgba(255,255,255,0.02)',
  border: '1px solid rgba(255,255,255,0.06)',
  borderRadius: '16px',
  padding: '32px',
  marginTop: '32px'
};

const BackButton = ({ onBack }) => (
  <button onClick={onBack} style={{
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#94a3b8', padding: '8px 20px',
    borderRadius: '8px', cursor: 'pointer',
    fontSize: '13px', marginBottom: '40px',
    fontFamily: 'DM Sans, sans-serif'
  }}>
    ← Back
  </button>
);

const Logo = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '40px' }}>
    <div style={{
      width: '36px', height: '36px', borderRadius: '10px',
      background: 'linear-gradient(135deg,#00c853,#1de9b6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '18px', fontWeight: '800', fontFamily: 'Syne, sans-serif'
    }}>V</div>
    <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800' }}>
      Vantage Studio AI
    </span>
  </div>
);

export function PrivacyPolicy({ onBack }) {
  return (
    <div style={pageStyle}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Syne:wght@700;800&display=swap');`}</style>
      <div style={containerStyle}>
        <Logo />
        <BackButton onBack={onBack} />

        <h1 style={headingStyle}>Privacy Policy</h1>
        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '8px' }}>
          Last updated: April 2026
        </p>
        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '32px' }}>
          Effective date: April 2026
        </p>

        <div style={cardStyle}>
          <p style={textStyle}>
            Vantage Studio AI ("Vantage", "we", "us", or "our") operates the website vantagestudioai.com and provides the Vantage content automation platform. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our services.
          </p>

          <h2 style={subHeadingStyle}>1. Information We Collect</h2>
          <p style={textStyle}>
            We collect information you provide directly to us including your name, email address and password when you create an account. We also collect payment confirmation information when you subscribe to a plan.
          </p>
          <p style={textStyle}>
            When you use our platform we collect information about your usage including videos you upload, channels you connect, content you create and publish, and platform connections you authorize through OAuth.
          </p>
          <p style={textStyle}>
            We automatically collect certain technical information including your IP address, browser type, device information, and usage patterns when you access our platform.
          </p>

          <h2 style={subHeadingStyle}>2. How We Use Your Information</h2>
          <p style={textStyle}>
            We use your information to provide and operate the Vantage platform, process your subscription and payments, publish content to your connected social media platforms on your behalf, generate AI powered metadata for your content, send you account and service notifications, and improve our platform and services.
          </p>

          <h2 style={subHeadingStyle}>3. OAuth and Platform Connections</h2>
          <p style={textStyle}>
            When you connect your YouTube, Facebook, Instagram or TikTok accounts through OAuth, we access only the permissions required to upload and publish videos on your behalf. We do not access your personal messages, contacts or any data beyond what is required for video publishing. You can revoke these permissions at any time from your platform settings.
          </p>

          <h2 style={subHeadingStyle}>4. Video Content</h2>
          <p style={textStyle}>
            Videos you upload to Vantage are stored temporarily on our servers solely for the purpose of publishing them to your connected platforms. Once published, videos are deleted from our servers. We do not analyze, share, sell or use your video content for any purpose other than publishing it on your behalf.
          </p>

          <h2 style={subHeadingStyle}>5. Data Sharing</h2>
          <p style={textStyle}>
            We do not sell your personal information to third parties. We may share your information with service providers who help us operate our platform including cloud hosting providers and AI services. We may disclose your information if required by law or to protect our rights.
          </p>

          <h2 style={subHeadingStyle}>6. Data Security</h2>
          <p style={textStyle}>
            We implement industry standard security measures to protect your information. All data is transmitted over encrypted HTTPS connections. Passwords are encrypted and never stored in plain text. However no method of transmission over the internet is 100% secure.
          </p>

          <h2 style={subHeadingStyle}>7. Data Retention</h2>
          <p style={textStyle}>
            We retain your account information for as long as your account is active. You may request deletion of your account and associated data at any time by contacting support@vantagestudioai.com. Video files are deleted from our servers immediately after successful publishing.
          </p>

          <h2 style={subHeadingStyle}>8. Your Rights</h2>
          <p style={textStyle}>
            You have the right to access, correct or delete your personal information. You may disconnect your social media accounts at any time. You may cancel your subscription at any time. To exercise these rights contact us at support@vantagestudioai.com.
          </p>

          <h2 style={subHeadingStyle}>9. Cookies</h2>
          <p style={textStyle}>
            We use essential cookies to maintain your login session and platform preferences. We do not use tracking cookies or advertising cookies.
          </p>

          <h2 style={subHeadingStyle}>10. Changes to This Policy</h2>
          <p style={textStyle}>
            We may update this Privacy Policy from time to time. We will notify you of significant changes by email or through the platform. Your continued use of Vantage after changes constitutes acceptance of the updated policy.
          </p>

          <h2 style={subHeadingStyle}>11. Contact Us</h2>
          <p style={textStyle}>
            If you have questions about this Privacy Policy contact us at:
          </p>
          <p style={{ ...textStyle, color: '#00c853' }}>
            Email: support@vantagestudioai.com<br />
            WhatsApp: 03114608845<br />
            Website: vantagestudioai.com
          </p>
        </div>
      </div>
    </div>
  );
}

export function TermsOfService({ onBack }) {
  return (
    <div style={pageStyle}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Syne:wght@700;800&display=swap');`}</style>
      <div style={containerStyle}>
        <Logo />
        <BackButton onBack={onBack} />

        <h1 style={headingStyle}>Terms of Service</h1>
        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '32px' }}>
          Last updated: April 2026
        </p>

        <div style={cardStyle}>
          <p style={textStyle}>
            These Terms of Service govern your use of the Vantage Studio AI platform at vantagestudioai.com. By creating an account or using our services you agree to these terms. Please read them carefully.
          </p>

          <h2 style={subHeadingStyle}>1. Acceptance of Terms</h2>
          <p style={textStyle}>
            By accessing or using Vantage you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms you may not use our platform.
          </p>

          <h2 style={subHeadingStyle}>2. Description of Service</h2>
          <p style={textStyle}>
            Vantage is an AI powered content automation platform that enables users to upload videos and automatically publish them to connected social media platforms including YouTube, Facebook, Instagram and TikTok. We provide AI generated metadata including titles, descriptions, keywords, hashtags and thumbnails.
          </p>

          <h2 style={subHeadingStyle}>3. Account Registration</h2>
          <p style={textStyle}>
            You must create an account to use Vantage. You are responsible for maintaining the security of your account and password. You must provide accurate and complete information when creating your account. You are responsible for all activities that occur under your account.
          </p>

          <h2 style={subHeadingStyle}>4. Subscription and Payment</h2>
          <p style={textStyle}>
            Vantage operates on a monthly subscription basis. Payments are processed manually via JazzCash or EasyPaisa. Your subscription begins upon confirmation of payment by our team. Subscriptions auto-renew monthly unless cancelled. You must notify us before the renewal date to cancel your subscription.
          </p>

          <h2 style={subHeadingStyle}>5. Acceptable Use</h2>
          <p style={textStyle}>
            You agree to use Vantage only for lawful purposes. You must not upload content that violates any laws, infringes intellectual property rights, contains harmful or illegal material, or violates the terms of service of connected platforms. You are solely responsible for the content you publish through Vantage.
          </p>

          <h2 style={subHeadingStyle}>6. Platform Compliance</h2>
          <p style={textStyle}>
            You are responsible for ensuring your content complies with the terms of service of YouTube, Facebook, Instagram, TikTok and any other platforms you publish to. Vantage is not responsible for any account suspensions, strikes or penalties imposed by those platforms on your accounts.
          </p>

          <h2 style={subHeadingStyle}>7. AI Generated Content</h2>
          <p style={textStyle}>
            Vantage uses artificial intelligence to generate metadata for your content. While we strive for accuracy and quality we do not guarantee the performance of AI generated titles, descriptions, keywords or thumbnails. Results may vary based on niche, content type and platform algorithm changes.
          </p>

          <h2 style={subHeadingStyle}>8. Intellectual Property</h2>
          <p style={textStyle}>
            You retain all rights to the content you upload and publish through Vantage. By using our platform you grant us a limited license to process and publish your content on your behalf. The Vantage platform, Obsidian AI technology and all associated branding are owned by Vantage Studio AI.
          </p>

          <h2 style={subHeadingStyle}>9. Limitation of Liability</h2>
          <p style={textStyle}>
            Vantage is provided on an as-is basis. We are not liable for any indirect, incidental or consequential damages arising from your use of our platform. Our total liability shall not exceed the amount you paid for your subscription in the past 30 days.
          </p>

          <h2 style={subHeadingStyle}>10. Service Availability</h2>
          <p style={textStyle}>
            We strive to maintain high availability of our platform but cannot guarantee uninterrupted service. We may perform maintenance or updates that temporarily affect availability. We are not liable for any losses resulting from service interruptions.
          </p>

          <h2 style={subHeadingStyle}>11. Termination</h2>
          <p style={textStyle}>
            We reserve the right to suspend or terminate your account if you violate these terms. You may cancel your account at any time by contacting support@vantagestudioai.com. Upon termination your access to the platform will cease immediately.
          </p>

          <h2 style={subHeadingStyle}>12. Changes to Terms</h2>
          <p style={textStyle}>
            We may update these Terms of Service from time to time. We will notify you of significant changes. Your continued use of Vantage after changes constitutes acceptance of the updated terms.
          </p>

          <h2 style={subHeadingStyle}>13. Contact</h2>
          <p style={{ ...textStyle, color: '#00c853' }}>
            Email: support@vantagestudioai.com<br />
            WhatsApp: 03114608845<br />
            Website: vantagestudioai.com
          </p>
        </div>
      </div>
    </div>
  );
}

export function ReturnPolicy({ onBack }) {
  return (
    <div style={pageStyle}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Syne:wght@700;800&display=swap');`}</style>
      <div style={containerStyle}>
        <Logo />
        <BackButton onBack={onBack} />

        <h1 style={headingStyle}>Return Policy</h1>
        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '32px' }}>
          Last updated: April 2026
        </p>

        <div style={{
          padding: '24px', borderRadius: '16px', marginBottom: '32px',
          background: 'rgba(239,68,68,0.08)', border: '2px solid rgba(239,68,68,0.3)'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '12px' }}>⚠️</div>
          <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#ef4444', marginBottom: '12px' }}>
            No Refund Policy
          </h2>
          <p style={{ fontSize: '14px', color: '#fca5a5', lineHeight: '1.7' }}>
            ALL SALES ARE FINAL. Once payment has been made and your Vantage subscription has been activated, NO REFUNDS will be issued under any circumstances. By completing payment and activating your subscription you explicitly agree to this no refund policy.
          </p>
        </div>

        <div style={cardStyle}>
          <h2 style={subHeadingStyle}>1. No Refund Policy</h2>
          <p style={textStyle}>
            Vantage Studio AI operates a strict no refund policy. Once a subscription payment has been received and your account has been activated, the payment is non-refundable. This applies to all subscription tiers including Starter, Creator, Pro, Agency and Enterprise plans.
          </p>

          <h2 style={subHeadingStyle}>2. Why We Have This Policy</h2>
          <p style={textStyle}>
            Our platform provides immediate access to AI powered tools and services upon activation. The costs associated with AI processing, server infrastructure, and platform maintenance are incurred immediately upon account activation. Due to the nature of digital services we are unable to recover these costs and therefore cannot issue refunds.
          </p>

          <h2 style={subHeadingStyle}>3. Before You Subscribe</h2>
          <p style={textStyle}>
            We strongly encourage you to review our features, pricing and terms carefully before subscribing. If you have any questions about our platform please contact us at support@vantagestudioai.com or WhatsApp 03114608845 before making payment. We are happy to answer any questions to help you make an informed decision.
          </p>

          <h2 style={subHeadingStyle}>4. Subscription Cancellation</h2>
          <p style={textStyle}>
            You may cancel your subscription at any time by contacting us. Cancellation stops future billing but does not entitle you to a refund for the current billing period. You will retain access to the platform until the end of your current billing period.
          </p>

          <h2 style={subHeadingStyle}>5. Exceptions</h2>
          <p style={textStyle}>
            The only exception to our no refund policy is if your account was activated in error due to a technical fault on our side. In such cases we will review the situation on a case by case basis. This does not include situations where you changed your mind, did not use the platform, or were unsatisfied with AI generated results.
          </p>

          <h2 style={subHeadingStyle}>6. Disputes</h2>
          <p style={textStyle}>
            If you have a concern about our service please contact us first at support@vantagestudioai.com. We will do our best to resolve any issues within 48 hours. Initiating a payment dispute or chargeback without contacting us first will result in immediate termination of your account.
          </p>

          <h2 style={subHeadingStyle}>7. Agreement</h2>
          <p style={textStyle}>
            By making payment to Vantage Studio AI you confirm that you have read and agreed to this Return Policy, our Terms of Service and our Privacy Policy. You understand that all payments are final and non-refundable.
          </p>

          <h2 style={subHeadingStyle}>8. Contact Us</h2>
          <p style={textStyle}>
            For any questions about this policy contact us before making payment:
          </p>
          <p style={{ ...textStyle, color: '#00c853' }}>
            Email: support@vantagestudioai.com<br />
            WhatsApp: 03114608845<br />
            Website: vantagestudioai.com
          </p>
        </div>
      </div>
    </div>
  );
}